import { useSelector } from "react-redux";
import React from "react";
import { StyledButton } from "../styled-button/StyledButton";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

const Hotspots = () => {
  const hotspots = useSelector((state) => state.annotations);
  const customizer = useSelector((state) => state.customizer);
  const {
    hotspotColor,
    hotspotTextColor,
    hotspotLabelBgColor,
    hotspotLabelTextColor,
    hotspotLabelBlur,
  } = customizer.hotspotStyle;

  const [currentlyVisible, setCurrentlyVisible] = React.useState("");

  const handleHotspotClick = (e, id) => {
    if (currentlyVisible !== id) {
      setCurrentlyVisible(id);
    } else {
      setCurrentlyVisible("");
    }
  };

  const hotspotList = hotspots.annotations.map((hotspot, idx) => {
    return (
      <button
        className={hotspot.classList}
        data-position={hotspot.dataset.position}
        data-normal={hotspot.dataset.normal}
        style={{ background: hotspotColor }}
        slot={hotspot.slot}
        key={Math.random().toString(36).substring(7)}
        name={hotspot.id}
        onClick={(e) => handleHotspotClick(e, hotspot.id)}
      >
        <div
          className={"annotation"}
          id={hotspot.id}
          style={{
            background: hotspotLabelBgColor,
            color: hotspotLabelTextColor,
            backdropFilter: hotspotLabelBlur,
            display: currentlyVisible === hotspot.id ? "block" : "none",
          }}
          key={Math.random().toString(36).substring(7)}
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            {hotspot.mediaImage !== "" && (
              <div
                className={"annotation-image"}
                style={{
                  background: `url(${hotspot.mediaImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
            )}
            {hotspot.text}
            <div>
              {hotspot.mediaVideo !== "" && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={hotspot.mediaVideo}
                >
                  <StyledButton
                    style={{ color: "#fff" }}
                    startIcon={<PlayArrowIcon />}
                  >
                    {" "}
                    watch Video
                  </StyledButton>
                </a>
              )}
            </div>
            <div>
              {hotspot.attachment !== "" && (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={hotspot.attachment}
                >
                  Download Attachment
                </a>
              )}
            </div>
          </div>
        </div>
        <span style={{ color: hotspotTextColor }} className={"annotation-idx"}>
          {++idx}
        </span>
      </button>
    );
  });

  return <>{hotspotList}</>;
};

export default Hotspots;
